export const OrbitalLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};